module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024"
    }
  }, [_c('path', {
    attrs: {
      "d": "M602.6 512l402.7-402.7c25-25 25-65.6 0-90.6-25-25-65.5-25-90.6 0l-402.7 402.7-402.7-402.7c-25-25-65.5-25-90.6 0-25 25-25 65.6 0 90.6l402.7 402.7-402.7 402.7c-25 25-25 65.6 0 90.6 12.5 12.5 28.9 18.7 45.3 18.7s32.8-6.3 45.3-18.8l402.7-402.7 402.7 402.7c12.5 12.5 28.9 18.8 45.3 18.8s32.8-6.3 45.3-18.8c25-25 25-65.6 0-90.6l-402.7-402.7z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78a2d8ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/icons/close.vue
// module id = 318
// module chunks = 22